import saveAs from 'file-saver';
import moment from 'moment';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from '../../../../components/Modal';
import AssociateLeaves from '../../../../components/SmartScheduler/AssociateLeaves';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config/index';
import '../../../SpringLoader/spinner.css';
import Flatpickr from 'react-flatpickr';
import { InputGroup } from 'react-bootstrap';
import 'flatpickr/dist/themes/material_blue.css';

const { API_URL } = config;

const MonthlyReports = ({
  activeClient,
  activeSite,
  sites = [],
  activeDate,
  activeWeek,
  schedules,
  siteAssociates,
  selectedDate,
  location: { search },
}) => {
  const params = qs.parse(search, { ignoreQueryPrefix: true });

  const padding = 90;
  let height = 425 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx,
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%,-' + offsetPx + ')',
    width: '50%',
    maxWidth: '40rem',
  };

  const leavesModalStyle = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: 'auto',
    maxHeight: '90vh',
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '70rem',
    overflowY: 'auto',
  };

  const today = new Date();
  const token = localStorage.getItem('token');

  // Monthly Reports Modal State
  const [showMonthlyReportsModal, setShowMonthlyReportsModal] = useState(false);
  const [monthlyReportsType, setMonthlyReportsType] =
    useState('Nestle-Timesheet');
  const [monthlyReportsSite, setMonthlyReportsSite] = useState('');
  const [monthlyReportsMonth, setMonthlyReportsMonth] = useState('');
  const [monthlyReportsYear, setMonthlyReportsYear] = useState('');
  const [capturedPhotoDateRange, setCapturedPhotoDateRange] = useState([]);
  const [dateRangeError, setDateRangeError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  // View Leaves Modal State
  const [showLeavesModal, setShowLeavesModal] = useState(false);

  const currentYear = new Date().getFullYear();
  const [previousYearDates, setPreviousYearDates] = useState([]);
  const reportSites = sites.length > 0 ? sites : activeSite ? [activeSite] : [];
  const allSitesSelected = Number(activeSite?.id) === 0;
  const selectedMonthlyReportsSite = reportSites.find(
    (site) => site.id == monthlyReportsSite
  );
  const monthlyReportsSiteName =
    monthlyReportsSite === 'all'
      ? 'All'
      : selectedMonthlyReportsSite?.name || activeSite?.name;

  // Convert activeDate from "MM-YYYY" format to proper date (first day of month)
  const getProperDate = () => {
    if (!activeDate) return new Date();

    // activeDate is in format "10-2025" (MM-YYYY)
    const [month, year] = activeDate.split('-');
    // Create date for the first day of the month
    return moment(`${year}-${month}-01`, 'YYYY-MM-DD').toDate();
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await handleDownloadMonthlyReports(event);
    }

    setValidated(true);
  };

  const handleDownloadMonthlyReports = async (event) => {
    event.preventDefault();

    // Validate date range for Captured-Photo
    if (monthlyReportsType === 'Captured-Photo') {
      if (capturedPhotoDateRange.length < 2) {
        setDateRangeError('Please select a date range.');
        return;
      }
      const [start, end] = capturedPhotoDateRange;
      const diffDays = moment(end).diff(moment(start), 'days');
      if (diffDays > 31) {
        setDateRangeError('Date range cannot exceed 1 month (31 days).');
        return;
      }
      setDateRangeError('');
    }

    setIsLoading(true);
    const requestSiteId =
      monthlyReportsSite === 'all'
        ? reportSites[0]?.id
        : monthlyReportsSite || activeSite?.id;

    if (!requestSiteId) {
      ToastUtil.error('Please select a site.');
      setIsLoading(false);
      return;
    }

    let url = `${API_URL}/site/${requestSiteId}/monthly_reports`;

    try {
      const body =
        monthlyReportsType === 'Captured-Photo'
          ? {
              type: monthlyReportsType,
              start_date: moment(capturedPhotoDateRange[0]).format(
                'YYYY-MM-DD'
              ),
              end_date: moment(capturedPhotoDateRange[1]).format('YYYY-MM-DD'),
            }
          : {
              type: monthlyReportsType,
              site_id: monthlyReportsSite,
              site_ids:
                monthlyReportsSite === 'all'
                  ? reportSites.map((site) => site.id)
                  : undefined,
              month: monthlyReportsMonth,
              year: monthlyReportsYear,
            };

      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let responseData = await response.json();
      if (response.ok) {
        const filename = `Monthly-Reports.xlsx`;
        const buffer = responseData.data.buffer.data;
        const arraybuffer = Uint8Array.from(buffer).buffer;
        const blob = new Blob([arraybuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, filename);
        setShowMonthlyReportsModal(false);
        setIsLoading(false);
      } else {
        ToastUtil.error(responseData.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  // Monthly Reports Modal Functions
  const handleOpenMonthlyReportsModal = () => {
    setMonthlyReportsType('Nestle-Timesheet');
    setMonthlyReportsSite(allSitesSelected ? 'all' : activeSite?.id || '');
    setCapturedPhotoDateRange([]);
    setDateRangeError('');

    if (selectedDate) {
      const [month, year] = selectedDate.split('-');
      const monthName = moment()
        .month(parseInt(month) - 1)
        .format('MMMM');
      setMonthlyReportsMonth(monthName);
      setMonthlyReportsYear(year);
    } else {
      setMonthlyReportsMonth('');
      setMonthlyReportsYear('');
    }
    setShowMonthlyReportsModal(true);
  };

  const handleCloseMonthlyReportsModal = () => {
    setIsLoading(false);
    setShowMonthlyReportsModal(false);
  };

  // View Leaves Modal Functions
  const handleOpenLeavesModal = () => {
    setShowLeavesModal(true);
  };

  const handleCloseLeavesModal = () => {
    setShowLeavesModal(false);
  };

  const generateYear = () => {
    const dates = [];
    for (let i = currentYear; i >= 2019; --i) {
      dates.push(i);
    }
    setPreviousYearDates(dates);
  };

  useEffect(() => {
    generateYear();
  }, []);

  useEffect(() => {
    if (activeSite) {
      setMonthlyReportsSite(allSitesSelected ? 'all' : activeSite.id);
    }
  }, [activeSite, allSitesSelected]);

  return (
    <React.Fragment>
      <div style={{ display: 'flex', gap: '10px' }}>
        {activeClient !== null &&
          activeSite !== null &&
          activeSite.enable_dl_monthly_reports && (
            <button
              type="button"
              onClick={handleOpenMonthlyReportsModal}
              className="btn btn-outline-brand"
            >
              Monthly Reports
            </button>
          )}

        {activeClient !== null &&
          activeSite !== null &&
          activeClient.enable_leave_credits == true && (
            <button
              type="button"
              onClick={handleOpenLeavesModal}
              className="btn btn-outline-brand"
            >
              View Leaves
            </button>
          )}
      </div>

      {/* Monthly Reports Modal */}
      <Modal
        showModal={showMonthlyReportsModal}
        customStyle={style}
        hideModal={handleCloseMonthlyReportsModal}
      >
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <h5>Monthly Reports</h5>
          <p>
            Retrieving Data for{' '}
            <strong>
              {activeClient.name} - {monthlyReportsSiteName}
            </strong>
            . <br />
            To view data for a different site, please select another site from
            the header.
          </p>
          <div className="d-flex flex-column m-4">
            <div className="mb-2">
              <label htmlFor="reportType">Type</label>
              <select
                required
                name="reportType"
                id="reportType"
                className="form-select"
                value={monthlyReportsType}
                onChange={({ target: { value } }) => {
                  setMonthlyReportsType(value);
                  setMonthlyReportsSite(
                    value === 'Captured-Photo' && allSitesSelected
                      ? ''
                      : allSitesSelected
                      ? 'all'
                      : activeSite?.id || ''
                  );
                  setCapturedPhotoDateRange([]);
                  setDateRangeError('');
                }}
              >
                <option value="">Please Select</option>
                <option value="Nestle-Timesheet">
                  Nestle Timesheet Template
                </option>
                <option value="Captured-Photo">Export Captured Photo</option>
              </select>
              <Form.Control.Feedback type="invalid">
                Please select type.
              </Form.Control.Feedback>
            </div>

            {/* Conditionally show date range OR month+year */}
            {monthlyReportsType === 'Captured-Photo' ? (
              <>
                {allSitesSelected && (
                  <div className="mb-2">
                    <label htmlFor="capturedPhotoSite">Site</label>
                    <select
                      required
                      name="capturedPhotoSite"
                      id="capturedPhotoSite"
                      className="form-select"
                      value={monthlyReportsSite}
                      onChange={({ target: { value } }) =>
                        setMonthlyReportsSite(value)
                      }
                    >
                      <option value="">Please Select</option>
                      {reportSites.map((site) => (
                        <option key={site.id} value={site.id}>
                          {site.name}
                        </option>
                      ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please select site.
                    </Form.Control.Feedback>
                  </div>
                )}
                <div className="mb-2">
                  <label>
                    Date Range{' '}
                    <small className="text-muted">(max 1 month)</small>
                  </label>
                  <InputGroup>
                    <Flatpickr
                      className="form-control d-block"
                      placeholder="Select date range"
                      value={capturedPhotoDateRange}
                      options={{
                        mode: 'range',
                        dateFormat: 'Y-m-d',
                        maxDate: capturedPhotoDateRange[0]
                          ? moment(capturedPhotoDateRange[0])
                              .add(31, 'days')
                              .toDate()
                          : undefined,
                      }}
                      onChange={(dates) => {
                        setCapturedPhotoDateRange(dates);
                        if (dates.length === 2) {
                          const diffDays = moment(dates[1]).diff(
                            moment(dates[0]),
                            'days'
                          );
                          if (diffDays > 31) {
                            setDateRangeError(
                              'Date range cannot exceed 1 month (31 days).'
                            );
                          } else {
                            setDateRangeError('');
                          }
                        } else {
                          setDateRangeError('');
                        }
                      }}
                    />
                  </InputGroup>
                  {dateRangeError && (
                    <div
                      className="text-danger"
                      style={{ fontSize: '0.875em', marginTop: '0.25rem' }}
                    >
                      {dateRangeError}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                {monthlyReportsType === 'Nestle-Timesheet' && (
                  <div className="mb-2">
                    <label htmlFor="reportSite">Site</label>
                    <select
                      required
                      name="reportSite"
                      id="reportSite"
                      className="form-select"
                      value={monthlyReportsSite}
                      onChange={({ target: { value } }) =>
                        setMonthlyReportsSite(value)
                      }
                    >
                      <option value="">Please Select</option>
                      {reportSites.length > 0 && (
                        <option value="all">All</option>
                      )}
                      {reportSites.length > 0 &&
                        reportSites.map((site) => (
                          <option key={site.id} value={site.id}>
                            {site.name}
                          </option>
                        ))}
                    </select>
                    <Form.Control.Feedback type="invalid">
                      Please select site.
                    </Form.Control.Feedback>
                  </div>
                )}

                <div className="mb-2">
                  <label htmlFor="reportMonth">Month</label>
                  <select
                    required
                    name="reportMonth"
                    id="reportMonth"
                    className="form-select"
                    value={monthlyReportsMonth}
                    onChange={({ target: { value } }) =>
                      setMonthlyReportsMonth(value)
                    }
                  >
                    <option value="">Please Select</option>
                    {moment.months().map((month, index) => (
                      <option value={month} key={index}>
                        {month}
                      </option>
                    ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    Please select month.
                  </Form.Control.Feedback>
                </div>

                <div className="mb-2">
                  <label htmlFor="reportYear">Year</label>
                  <select
                    required
                    name="reportYear"
                    id="reportYear"
                    className="form-select"
                    value={monthlyReportsYear}
                    onChange={({ target: { value } }) =>
                      setMonthlyReportsYear(value)
                    }
                  >
                    <option value="">Please Select</option>
                    {previousYearDates.map((y, index) => (
                      <option value={y} key={index}>
                        {y}
                      </option>
                    ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    Please select year.
                  </Form.Control.Feedback>
                </div>
              </>
            )}
          </div>
          <div className="d-flex justify-content-end mt-auto pt-3 me-4">
            <button
              type="button"
              onClick={handleCloseMonthlyReportsModal}
              className="btn btn-outline-brand"
              style={{ width: '10rem' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading ? true : false}
              className={
                isLoading
                  ? 'btn btn-brand ms-3 loading text'
                  : 'btn btn-brand ms-3'
              }
              style={{ width: '10rem', position: 'relative', height: '38px' }}
            >
              <div className="spinner" />
              <p className="text">Download</p>
            </button>
          </div>
        </Form>
      </Modal>

      {/* View Leaves Modal */}
      <Modal
        showModal={showLeavesModal}
        customStyle={leavesModalStyle}
        hideModal={handleCloseLeavesModal}
      >
        <AssociateLeaves
          activeDate={getProperDate()}
          siteAssociates={siteAssociates}
          type="month"
        />
        <div className="d-flex justify-content-end mt-auto pt-3 me-4">
          <button
            type="button"
            onClick={handleCloseLeavesModal}
            className="btn btn-outline-brand"
            style={{ width: '10rem' }}
          >
            Close
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default MonthlyReports;
